import type { MessageKey } from 'types/LocaleMessageKey';

import { ACCESSORIES_ROOT_PATH, POP_PATHNAME } from '@/app/consts/pathnames';
import { RingModelEnum } from '@/app/enums/RingModelEnum';

import type CurrentRouteValues from '../_hooks/useCurrentRoute/types';
import WizStepId from '../_steps/enums/WizStepId';

export interface Breadcrumb {
  title: MessageKey;
  enumVal: WizStepId;
  checkIsValid: (steps: CurrentRouteValues) => boolean;
  getHref: (currentRoute: CurrentRouteValues) => string;
  isAccessory?: boolean;
  isOuraRing4Wizard?: boolean;
}

//Must have conditonal check for href to stop trailing back slash error
const BREADCRUMBS: Breadcrumb[] = [
  {
    title: 'step_style_model_tab',
    enumVal: WizStepId.Accessory,
    checkIsValid: ({ accessory }) => accessory.isValid,
    getHref: ({ accessory }) =>
      accessory.isValid ? `${ACCESSORIES_ROOT_PATH}/${accessory.value}` : '',
    isAccessory: true,
    isOuraRing4Wizard: false,
  },
  {
    title: 'step_style_title',
    enumVal: WizStepId.Style,
    checkIsValid: ({ style }) => style.isValid,
    getHref: ({ style }) =>
      style.isValid
        ? `${POP_PATHNAME}/${RingModelEnum.Gen3}/${style.value}`
        : '',
    isAccessory: false,
    isOuraRing4Wizard: false,
  },
  {
    title: 'step_finish_title',
    enumVal: WizStepId.Finish,
    checkIsValid: ({ finish }) => finish.isValid,
    getHref: ({ style, finish }) =>
      finish.isValid
        ? `${POP_PATHNAME}/${RingModelEnum.Gen3}/${style.value}/${finish.value}`
        : '',
    isAccessory: false,
    isOuraRing4Wizard: false,
  },
  {
    title: 'step_finish_title',
    enumVal: WizStepId.Finish,
    checkIsValid: ({ finish }) => finish.isValid,
    getHref: ({ finish }) =>
      finish.isValid
        ? `${POP_PATHNAME}/${RingModelEnum.Oura4}/${finish.value}`
        : '',
    isAccessory: false,
    isOuraRing4Wizard: true,
  },
  {
    title: 'step_size_title',
    enumVal: WizStepId.Size,
    checkIsValid: ({ size }) => size.isValid,
    getHref: ({ accessory, size }) =>
      size.isValid
        ? `${ACCESSORIES_ROOT_PATH}/${accessory.value}/${size.value}`
        : '',
    isAccessory: true,
    isOuraRing4Wizard: false,
  },
  {
    title: 'step_size_title',
    enumVal: WizStepId.Size,
    checkIsValid: ({ size }) => size.isValid,
    getHref: ({ style, finish, size }) =>
      size.isValid
        ? `${POP_PATHNAME}/${RingModelEnum.Gen3}/${style.value}/${finish.value}/${size.value}`
        : '',
    isAccessory: false,
    isOuraRing4Wizard: false,
  },
  {
    title: 'step_size_title',
    enumVal: WizStepId.Size,
    checkIsValid: ({ size }) => size.isValid,
    getHref: ({ finish, size }) =>
      size.isValid
        ? `${POP_PATHNAME}/${RingModelEnum.Oura4}/${finish.value}/${size.value}`
        : '',
    isAccessory: false,
    isOuraRing4Wizard: true,
  },
];

export default BREADCRUMBS;
